module.exports = __webpack_public_path__ + "img/area.09484c46.png";